import ReactOnRails from 'react-on-rails/client';
import RegionalOrganizations from '../../app/RegionalOrganizations.js';

ReactOnRails.register({RegionalOrganizations});